import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HowToService, IHowTo, TabItem,AuthStateService } from '@sml/utility';
import { IconsComponent } from '@sml/icons';
import { CommonModule } from '@angular/common';
import { SpinnerService } from '@sml/spinner';
import { HowToComponent } from '@sml/how-to';

@Component({
  selector: 'sml-tabs',
  standalone: true,
  imports: [CommonModule, RouterModule, IconsComponent, HowToComponent],
  templateUrl: './tabs.component.html',
})
export class TabsComponent {
  private readonly howToService = inject(HowToService);
  private readonly spinnerService = inject(SpinnerService);
  authState = inject(AuthStateService);
  @Input() tabs: TabItem[] = [];
  @Input() switchTab = true;
  @Input() activeTab!: string;
  @Input() variation: 'default' | 'filled' = 'default';
  @Input() kind: 'default' | 'full' = 'default';
  @Input() dataLength=false;
  @Output() activeTabChange = new EventEmitter<string>();
  @Input() customclassesForTab=false;
  @Input() fromActivityLog=false;
  @Input() tabWidth = '!tw-w-[132.5px]'



  onTabClick(tabKey: string): void {
    this.activeTab = tabKey;
    this.activeTabChange.emit(this.activeTab);
  }

 getTabClasses(tabKey: string): string {
  if (this.variation === 'default') {
    return this.activeTab === tabKey
      ? 'tw-text-sm tw-leading-normal xl:tw-text-base 2xl:tw-text-lg tw-text-primary-700 tw-font-bold'
      : 'tw-text-sm tw-leading-normal xl:tw-text-base 2xl:tw-text-lg tw-text-grey-750 tw-font-medium tw-pb-3';
  } else {
    if (this.activeTab === tabKey && !this.fromActivityLog) {
      return 'tw-text-sm tw-bg-primary-700 tw-text-white tw-font-bold tw-rounded-lg tw-py-2 tw-px-3';
    }
    else if (this.activeTab === tabKey && this.fromActivityLog) {
      return 'tw-text-sm tw-bg-[#F0F7FB] tw-text-[#041519] tw-font-bold tw-rounded-lg tw-py-2 tw-px-3';

    }
    const textColorClass = this.fromActivityLog ? 'tw-text-[#828485]' : 'tw-text-grey-750';
    return `tw-text-sm ${textColorClass} tw-font-medium tw-px-3 tw-py-2`;
  }
}

  getCustomClass(tabKey: string, index:number): string {
    const baseClass = this.activeTab === tabKey
    ? `tw-text-sm tw-bg-[#4089A5] tw-text-white tw-font-bold ${this.tabWidth} !tw-h-[44px] tw-flex tw-justify-center tw-border tw-border-[#e3e3e3]`
    : `tw-text-sm tw-text-[#041519] tw-font-medium ${this.tabWidth} !tw-h-[44px] tw-justify-center tw-border tw-border-[#e3e3e3] tw-bg-white`;

  const sideClass = index % 2 !== 0
    ? 'tw-rounded-tr-lg tw-rounded-br-lg'
    : 'tw-rounded-tl-lg tw-rounded-bl-lg';

  return `${baseClass} ${sideClass}`;
  }
  howtoModal = signal(false);
  howtoData = signal<IHowTo | null>(null);
  showHowTo($event: MouseEvent | Event, howToId: string){
    $event.stopPropagation();
    $event.preventDefault();

    this.spinnerService.showSpinner();
    this.howToService.getHowToWithActions(howToId)
      .subscribe({
        next: (howTo: IHowTo) => {
          this.howtoData.set(howTo);
          this.howtoModal.set(true);
          this.spinnerService.hideSpinner();
        },
        error: (error) => {
          this.spinnerService.hideSpinner();
          console.error('error occoured', error)
        }
      })
  }
  closeModal(){
    this.howtoModal.set(false);
  }
}
